import { ColorGroupApi } from '@/types/Color';
import { ColorGroup as ColorGroupType } from '@/types/Color';
import { GraphicElement, GraphicElementApi } from '@/types/GraphicElement';
import { Engine } from '@/engine/core/Engine';
import { ColorGroup as EngineColorGroup } from '@/engine/entities/ColorGroup';
import { Color as EngineColor } from '@/engine/entities/Color';

export class GraphicElementMapper {
    static getGraphiElementFromEngineContent(graphicElementData: GraphicElementApi): GraphicElement {
        const { uuid, type, options } = graphicElementData;
        const graphicElement: GraphicElement = {
            uuid: uuid,
            type: type,
            key: uuid,
            content: this.getContentByType(graphicElementData),
            options: { ...options },
            angle: graphicElementData.angle,
            width: graphicElementData.size.width,
            height: graphicElementData.size.height,
            scaleX: graphicElementData.scale.scaleX * Engine.getInstance().canvas.width,
            scaleY: graphicElementData.scale.scaleY * Engine.getInstance().canvas.height
        };
        if (graphicElementData.colorGroups) {
            graphicElement.colors = graphicElementData.colorGroups.map((colorGroup) => ({
                hexaValue: colorGroup.color.hexaValue,
                id: colorGroup.id
            }));
        }

        return graphicElement;
    }

    static getContentByType(element: GraphicElementApi) {
        if (element.type == 'Text') {
            return element.content;
        } else if (['Graduation', 'Image', 'ImageSVG'].includes(element.type)) {
            return element.content.getContent();
        } else if (element.type == 'backPattern' || element.type == 'BackPattern') {
            return element.options.patternPath;
        }
    }

    static getColorGroupsFromData(colors: ColorGroupType[]): ColorGroupApi[] {
        const colorGroups: ColorGroupApi[] = [];
        colors.forEach((color) => {
            colorGroups.push(new EngineColorGroup(color.id, new EngineColor(color.hexaValue)));
        });

        return colorGroups;
    }
}
